import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-facebook-page-insights-checklist',
  templateUrl: './help-facebook-page-insights-checklist.component.html'
})
export class HelpFacebookPageInsightsChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
